import Box from "@/components/Box";
import Stack from "@/tpo/Stack";

function formatLabDate(value) {
  if (!value) {
    return "—";
  }
  return new Date(value).toLocaleDateString();
}

function formatExpiryDate(sampleReceivedByLab) {
  if (!sampleReceivedByLab) {
    return "—";
  }
  return new Date(
    new Date(sampleReceivedByLab).getTime() + 83 * 24 * 60 * 60 * 1000
  ).toLocaleDateString();
}

/**
 * Summary rows for a Cyrex stored / historical sample (matches purchase-option UI in CyrexProductDetail).
 * @param {object} props
 * @param {{ providerItemId?: string, providerTestId?: string, order?: { id?: string }, sampleReceivedByLab?: string, isValidForCyrexSample?: boolean } | null} props.sample
 * @param {boolean} [props.panel] — when true, wraps content in a full-width haze background box (basket listing).
 * @param {string} [props.title]
 */
export default function CyrexStoredSampleSummary({
  sample,
  panel = false,
  title = "Stored sample for this patient"
}) {
  if (!sample) {
    return null;
  }

  const inner = (
    <>
      <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]} mb={12}>
        {title}
      </Box>
      <Stack gap={6}>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Requisition Id: {sample.providerItemId || "—"}
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Sample Id: {sample.providerTestId || "—"}
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Order number: {sample.order?.id || "—"}
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Sample taken: {formatLabDate(sample.sampleReceivedByLab)}
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Expiry: {formatExpiryDate(sample.sampleReceivedByLab)}
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Is valid: {sample.isValidForCyrexSample ? "✅" : "❌"}
        </Box>
      </Stack>
    </>
  );

  if (panel) {
    return (
      <Box
        bg="haze"
        p={[20, 20, 40]}
        width="100%"
        data-component-name="CyrexStoredSampleSummaryPanel"
      >
        {inner}
      </Box>
    );
  }

  return <Box data-component-name="CyrexStoredSampleSummary">{inner}</Box>;
}
